import { Component, Input, TemplateRef } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ThemeService } from '../../services/ThemeService';

@Component({
  selector: 'app-footer1',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  @Input() modalRef!: NgbModalRef
  isDarkMode = false;
  constructor(private router: Router,
    private modalService: NgbModal,
    private themeService: ThemeService
  ) { }

  ngOnInit(): void {
    this.themeService.isDarkMode$.subscribe(mode => {
      this.isDarkMode = mode;
    });
  }
  // termss(template: TemplateRef<any>): void {
  //   this.modalRef = this.modalService.open(template, { size: 'lg', });
  // }
  // callbackFun3() {
  //   this.termAccept = false
  //   this.termReject = true
  // }
  // callbackFun2() {
  //   this.termAccept = true
  //   this.termReject = false
  // }
}